import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"no-gutters":"","align":"center"}},[_c(VCol,{staticClass:"pb-sm-0 pb-3",attrs:{"cols":"12","sm":"3"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c(VCol,{attrs:{"cols":"12","sm":"9"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }